import styled from "styled-components";

export const SSelectProjectStepHeader = styled.div`
  padding: 16px;
  display: flex;
  align-items: center;
  gap: 12px;
  border-bottom: 1px solid var(--ui-03);
`;
